// extracted by mini-css-extract-plugin
export var hideEditor = "_n8-2";
export var infoIcon = "_n8-3";
export var label = "_n8-1";
export var labelContainer = "_n8-0";
export var readonlyText = "_n8-4";